<template>
  <div class="header">
    <h1><img src="/img/logo.jpg" /></h1>
    <div class="text-fuwu"><img src="/img/right_text.jpg" />
      <div class="text-fuwu-content">
        拙诚厚重,服务测绘地信行业。明理躬行,创造用户长期价值。
      </div>
    </div>

  </div>
  <div class="nav-menu-bg">
    <div class="nav-menu">
      <ul>
        <li v-for="(item, index) in menus" @click="goPage(item)">{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { watch, onMounted, onUnmounted } from "vue";

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();
const menus = [
  {
    name: "首页",
    link: '/'
  },
  {
    name: "政务产品",
    link: '/news?type=zwcp'
  },
  {
    name: "安全产品",
    link: '/news?type=aqcp'
  },
  {
    name: "项目案例",
    link: '/news?type=xmal'
  },
  {
    name: "通知公告",
    link: '/news?type=tzgg'
  },
  {
    name: "资质荣誉",
    link: '/news?type=zzry'
  },
  {
    name: "常见问题",
    link: '/news?type=cjwt'
  },
  {
    name: "关于我们",
    link: '/aboutUs'
  },
]

function goPage(item) {
  router.push(item.link)
} 
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  width: 100%;
  max-width: 1166px;
  width: 100%;
  height: 4.2rem;
  overflow: hidden;
  margin: 0 auto;
  padding-top: 1.5rem;
  color: #fff;
  background-color: #fff;

  h1 {
    float: left;

    img {
      width: 25.6rem;
    }
  }

  .text-fuwu {
    float: right;
  }

  .text-fuwu-content {
    font-size: 12px;
    line-height: 1.8rem;
    color: #4b91ee;
  }
}

.nav-menu-bg {
  width: 100%;
  margin-top: 1.4rem;
  background: #055ccd;

  .nav-menu {
    width: 100%;
    height: 4rem;
    margin-top: 1.4rem;

    .scroll-text {
      font-weight: bold;
      font-size: 1rem;
      max-width: 1166px;
      width: 100%;
      margin: 0 auto;
      line-height: 4.6rem;
    }

    ul {
      max-width: 1166px;
      width: 100%;
      margin: 0 auto;
      display: flex;

      li {
        font-size: 1.2rem;
        width: 12.5rem;
        height: 4.375rem;
        text-align: center;
        line-height: 4.375rem;
        color: #fff;

        &:hover {
          height: 4rem;
          background-color: #06479c;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
